export default __webpack_public_path__ + "static/media/freelancing.92027cdb.jpg";